import { apiClient } from "./client";

export type SlackLinkResponse = {
  provider: "slack";
  slack_team_id: string;
  slack_user_id: string;
  thread_user_id: string;
  thread_email: string;
  thread_display_name: string;
};

export function linkSlackIdentity(token: string): Promise<SlackLinkResponse> {
  return apiClient<SlackLinkResponse>("/integrations/slack/link", {
    method: "POST",
    body: { token },
  });
}
